import styled from 'styled-components';
import { Text } from '@oneaudi/unified-web-alpha-components';
import { SYS_BREAKPOINT_MD } from '@oneaudi/unified-web-alpha-common';
export const PriceStyles = styled.div `
  display: flex;
  align-items: baseline;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 0 4px;
`;
export const PriceStylesText = styled(Text) `
  color: ${(props) => props.theme.sys.color.text.headline.default};
  @media screen and (max-width: ${SYS_BREAKPOINT_MD}) {
    &:last-child {
      font-size: 12px;
    }
  }
`;
export const OrWrapperStyles = styled.div `
  @media screen and (max-width: ${SYS_BREAKPOINT_MD}) {
    word-break: break-all;
  }
`;
